import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {redirect, RouteObject} from 'react-router';

const customPageRoutes: RouteObject[] = (
  getBootstrapData().custom_page_slugs || []
).map(slug => ({
  path: slug,
  handle: {slug},
  lazy: () => import('@common/custom-page/custom-page-layout'),
}));

export const commonRoutes: RouteObject[] = [
  {
    path: 'contact',
    lazy: () => import('@common/contact/contact-us-page'),
  },
  {
    path: 'pages/:pageSlug',
    loader: ({params}) => redirect(`/${params.pageSlug}`),
  },
  {
    path: 'pages/:pageId/:pageSlug',
    loader: ({params}) => redirect(`/${params.pageSlug}`),
  },
  ...customPageRoutes,
  {
    path: '404',
    element: <NotFoundPage />,
  },
];
